import React from 'react';
export default function FlexRow(props) {
  let style = { ...Styles.flexRow, alignItems: 'center' };

  if (props.reverse) style.flexDirection = 'row-reverse';
  if (props.justifyContent) style.justifyContent = props.justifyContent;
  if (props.alignItems) style.alignItems = props.alignItems;
  if (props.expand) style = { ...style, ...props.expand };

  const handleClick = (e) => {
    if (props.onClick) props.onClick(e);
  };

  return (
    <div style={style} onClick={handleClick}>
      {props.children}
    </div>
  );
}

const Styles = {
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flex: 1,
    width: '100%',
    height: '100%',
  },
};
